'use client';

import { UiProvider as Provider } from '@jouzen/ecom-components/layout';
import {
  CurrencyProvider,
  type CurrencyProviderProps,
} from '@jouzen/ecom-components/v3/Price';
import Image from 'next/image';
import Link from 'next/link';
import type { PropsWithChildren } from 'react';

import useCurrency from '../hooks/useCurrency';

interface UiProviderProps {
  readonly currencyProps: Pick<CurrencyProviderProps, 'freeMessage'>;
  readonly locale: string;
}

function UiProvider({
  children,
  currencyProps,
  locale,
}: PropsWithChildren<UiProviderProps>) {
  const { countryData, currencyCode } = useCurrency();

  const _currencyProps: CurrencyProviderProps = {
    country: countryData?.countryCode ?? 'US',
    fallbackCurrencyCode: currencyCode,
    fallbackLocale: locale,
    locale,
    ...currencyProps,
  };
  return (
    <Provider
      // @ts-expect-error --Fix type error
      ImageComponent={Image}
      LinkComponent={Link}
      intlProps={{ locale }}
    >
      <CurrencyProvider {..._currencyProps}>{children}</CurrencyProvider>
    </Provider>
  );
}

export default UiProvider;
